import { TeamsTheme } from "../constants";
export default {
    theme: TeamsTheme.HighContrast,
    colorScheme: {
        elevations: {
            2: "none",
            4: "none",
            8: "none",
            16: "none",
            32: "none",
            64: "none",
        },
    },
};
//# sourceMappingURL=site-variables.js.map